import { surveyLocalization } from 'survey-core';

export const customLocaleStringsSl = {
  pagePrevText: 'Prejšnja',
  pageNextText: 'Naprej',
  completeText: 'Dokončano',
  previewText: 'Predogled',
  editText: 'Uredi',
  startSurveyText: 'Začetek',
  otherItemText: 'Drugo (prosimo, navedite)',
  noneItemText: 'Nič ne velja',
  selectAllItemText: 'Izberi vse',
  progressText: 'Stran {0} od {1}',
  panelDynamicProgressText: 'Vnos {0} od {1}',
  questionsProgressText: 'odgovorjeno na {0}/{1} vprašanj',
  emptySurvey: 'Ni vprašanj.',
  completingSurvey: 'Hvala, ker ste izpolnili anketo!',
  completingSurveyBefore: 'Zaznali smo, da ste to anketo že izpolnili.',
  loadingSurvey: 'Nalaganje ankete ...',
  placeholder: 'Prosimo izberite ...',
  vrednost: 'Vrednost',
  requiredError: 'Prosimo, odgovorite na to vprašanje.',
  requiredErrorInPanel: 'Prosimo, odgovorite na vsaj eno vprašanje.',
  requiredInAllRowsError: 'Prosimo, odgovorite na vsa vprašanja.',
  numericError: 'Vrednost mora biti število.',
  textMinLength: 'Prosimo, vnesite vsaj {0} znakov.',
  textMaxLength: 'Prosimo, ne vnesite več kot {0} znakov.',
  textMinMaxLength: 'Prosimo, vnesite najmanj {0} in največ {1} znakov.',
  minRowCountError: 'Prosimo, vnesite vsaj {0} vrstic.',
  minSelectError: 'Izberite vsaj {0} odgovor(ov).',
  maxSelectError: 'Prosimo, ne izberite več kot {0} odgovor(ov).',
  numericMinMax: '\'{0}\' mora biti večji ali enak {1} in manjši ali enak {2}',
  numericMin: '\'{0}\' mora biti večji ali enak {1}',
  numericMax: '\'{0}\' mora biti manjši ali enak {1}',
  invalidEmail: 'Prosimo, vnesite veljaven e-poštni naslov.',
  invalidExpression: 'Izraz: {0} mora vrniti vrednost \'true\'.',
  urlRequestError: 'Omrežna storitev je vrnila naslednjo napako \'{0}\'. {1}',
  urlGetChoicesError: 'Omrežna storitev je vrnila neveljavne podatke',
  exceedMaxSize: 'Datoteka ne sme biti večja od {0}.',
  otherRequiredError: 'Prosimo, navedite vrednost.',
  uploadingFile: 'Prosimo, počakajte, da se vaše datoteke nalagajo.',
  loadingFile: 'Nalaganje...',
  selectFile: 'Izberi datoteko(e)...',
  fileDragAreaPlaceholder: 'Spustite datoteko sem ali kliknite spodnji gumb, da naložite datoteko.',
  noFileChosen: 'Ni izbrana datoteka',
  confirmDelete: 'Ali želite izbrisati vnos?',
  keyDuplicationError: 'Ta vrednost mora biti edinstvena.',
  addColumn: 'Dodaj stolpec',
  addRow: 'Dodaj vrstico',
  removeRow: 'Odstrani',
  addPanel: 'Dodaj novo',
  removePanel: 'Odstrani',
  options_Item: 'Predmet',
  matrix_column: 'Stolpec',
  matrix_row: 'vrstica',
  savingData: 'Rezultati so shranjeni na strežnik ...',
  savingDataError: 'Prišlo je do napake. Rezultatov ni bilo mogoče shraniti.',
  savingDataSuccess: 'Rezultati so bili shranjeni!',
  saveAgainButton: 'Pošlji ponovno',
  timerMin: 'Min.',
  timerSec: 'Sek.',
  timerSpentAll: 'Bili ste {0} na tej strani in porabili skupno {1}.',
  timerSpentPage: 'Na tej strani ste bili {0}.',
  timerSpentSurvey: 'Skupaj ste porabili {0}.',
  timerLimitAll: 'Na tej strani ste bili {0} od {1} in potrebovali ste skupno {2} od {3}.',
  timerLimitPage: 'Bili ste {0} od {1} na tej strani.',
  timerLimitSurvey: 'Uporabili ste skupno {0} od {1}.',
  clearCaption: 'Odstrani izbor',
  chooseFileCaption: 'Izberi datoteko',
  removeFileCaption: 'Izbriši datoteko',
  booleanCheckedLabel: 'Da',
  booleanUncheckedLabel: 'Ne',
  confirmRemoveFile: 'Ali ste prepričani, da želite izbrisati to datoteko: {0}?',
  confirmRemoveAllFiles: 'Ali ste prepričani, da želite izbrisati vse datoteke?',
  questionTitlePatternText: 'Naslov vprašanja',
  ratingOptionsCaption: 'Dotaknite se za oceno ...',
  emptyRowsText: 'Ni vrstic.',
  filterStringPlaceholder: 'Vnesite za iskanje ...',
  indexText: '{0} od {1}',
  minError: 'Vrednost ne sme biti manjša od {0}',
  maxError: 'Vrednost ne sme biti večja od {0}',
  modalApplyButtonText: 'Uporabi',
  modalCancelButtonText: 'Prekliči',
  multipletext_itemname: 'Besedilo',
  noEntriesText: 'Ni še nobenega vnosa.\nKliknite spodnji gumb, da dodate nov vnos.',
  signaturePlaceHolder: 'Podpiši se tukaj',
};

export function fixSlLanguage(): void {
  surveyLocalization.locales['sl'] = customLocaleStringsSl;
}
